<template lang="pug">
.Root
  //- Debug(v-if="isDebug")
  Topbar
  PrivacyContest(v-if="$route.path !== ROUTES.PRIVACY && !privacySets",
      @save="handlePrivacySetsSave")

  //- template(v-if="false")
  //-   video.__bgVideo(v-if="mq.width <= 420", :src="bg420VideoSrc", @canplay="onBgVideoLoad",
  //-     autoplay, loop, muted, preload, playsinline)
  //-   video.__bgVideo(v-else-if="mq.sm", :src="bgSmVideoSrc", @canplay="onBgVideoLoad",
  //-     autoplay, loop, muted, preload, playsinline)
  //-   video.__bgVideo(v-else, :src="bgLgVideoSrc", @canplay="onBgVideoLoad",
  //-     autoplay, loop, muted, preload, playsinline)

  //- video.__bgVideo.--bg2(v-else, :src="bgVideo2Src", @canplay="onBgVideoLoad",
  //-   autoplay, loop, muted, preload, playsinline)

  Particles(v-if="!DEV")
  .Root__bg
  main.t-miniscroll.__pages(v-if="$route.path !== ROUTES.ROOT", ref="main")
    .LndSection.--pad(v-if="$route.path === ROUTES.CASES")
      LndCases.l-mw

    template(v-else-if="$route.path === ROUTES.ABOUT")
      .LndSection.--pad: LndAbout.l-mw
      .LndSection.--pad: LndTeam.l-mw

    .LndSection.--pad(v-else-if="$route.path === ROUTES.SERVICES")
      LndAreasOfWork.l-mw

    .LndSection.--pad(v-else-if="$route.path === ROUTES.PRIVACY")
      PrivacyPage.l-mw

    LndGMP(v-else-if="$route.path === ROUTES.GMP")

  template(v-else)
    //- Lever(v-if="!mq.sm")
    main.u-span-y.t-miniscroll(ref="main", style="--gap-v: 0")

      .LndSection.--pad.--sm-mh(:id="SECTION_ID.INTRO")
        IntroMap(ref="introMap")
        //- .--shit-bg
        LndIntro.l-mw

      .LndSection.--pad(:id="SECTION_ID.INTRO")
        LndWeDo.l-mw

      .LndSection.--pad
        LndServices.l-mw

      .LndSection.--pad(:id="SECTION_ID.PRODUCTS")
        LndProducts.l-mw

      .LndSection.--pad
        LndClients.l-mw

      //- .LndSection.--pad
      //-   LndAchs.l-mw


      .LndSection.--pad(:id="SECTION_ID.CONTACTS")
        LndContacts.l-mw

  PrivacyContest(v-if="!TEST && !privacySets",
      @openSets="$refs.privacySetsModal.toggle()", @save="handlePrivacySetsSave")
  PrivacySetsModal(ref="privacySetsModal", :sets="privacySets",
      @save="handlePrivacySetsSave")
</template>
<script>
import { defineAsyncComponent } from 'vue';
// import bokalSourage from 'services/bokalSourage';
// import E from 'services/emitter';
import MediaQuery from 'components/MediaQuery';

import Lever from 'components/Lever';
import Topbar from 'components/Topbar';
import LndIntro from 'components/LndIntro';
import LndServices from 'components/LndServices';
import LndProducts from 'components/LndProducts';
import LndAchs from 'components/LndAchs';
import LndContacts from 'components/LndContacts';
import LndClients from 'components/LndClients';
import LndAreasOfWork from 'components/LndAreasOfWork';
import LndCases from 'components/LndCases';
import LndTeam from 'components/LndTeam';
import LndAbout from 'components/LndAbout';
import LndGMP from 'components/LndGMP';
import LndWeDo from 'components/LndWeDo';
import PrivacyPage from 'components/PrivacyPage';
import PrivacyContest from 'components/PrivacyContest';
import PrivacySetsModal from 'components/PrivacySetsModal';
import IntroMap from 'components/IntroMap';

import GTM, { PrivacySets } from 'services/GTM';
import { setScrollable, emitOnScroll } from 'services/scroll';
import { isFlexGapSupported } from 'const';

import ROUTES from 'routes';
// import bgLgVideoSrc from 'assets/imgs/bg.scale1440.crf30.mp4';
// import bgSmVideoSrc from 'assets/imgs/bg.scale1440.crop740.crf30.mp4';
// import bg420VideoSrc from 'assets/imgs/bg.scale1440.crop420.crf30.mp4';
// import bgVideo2Src from 'assets/imgs/bg2.crf22.mp4';

const Particles = defineAsyncComponent(() => import('components/Particles'));
// import Debug from 'components/Debug';

export default {
  name: 'Root',
  mixins: [MediaQuery],

  static: () => ({
    // bgLgVideoSrc,
    // bgSmVideoSrc,
    // bg420VideoSrc,
    // bgVideo2Src,
    SECTION_ID: Object.entries(ROUTES).reduce((acc, [name, route]) => {
      if (route.startsWith('/#'))
        acc[name] = route.substr(2);
      return acc;
    }, {}),
  }),

  data: () => ({
    privacySets: PrivacySets.get(),
  }),

  methods: {
    onBgVideoLoad ({ target }) { target.classList.add('--load') },

    scrollWithHash () {
      const { hash } = window.location;
      const [, sectionId] = hash.match(/\#([\d\w]+)/) || [];
      console.log('scrollWithHash: ', sectionId);

      if (sectionId)
        setTimeout(() => {
          this.$el.querySelector(`#${ sectionId }`)?.scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => { this.$refs?.introMap.onScroll() }, 10);
        }, 800);
    },

    handlePrivacySetsSave (privacySets = {}) {
      const {
        analytical = true,
        marketing = true,
        necessary = true,
      } = privacySets;
      const _sets = { analytical, marketing, necessary };
      PrivacySets.set(_sets);
      GTM.consentUpdated();
      this.privacySets = _sets;
    },
  },

  created () {
    window.$App = this;
    if (!isFlexGapSupported)
      this.$nextTick(() => this.$el.classList.add('--no-flex-gap'));
  },

  mounted () {
    this.scrollWithHash();
    // setScrollable(this.$refs.main);
    this.$nextTick(emitOnScroll);
  },

  watch: {
    $route () {
      const { main } = this.$refs;

      this.$nextTick(() => {
        main?.style.setProperty('--children-len', main.children.length - 1);
        setScrollable(this.$route.path === ROUTES.ROOT ? this.$refs.main : window);
        this.scrollWithHash();
      });

      const isOverflow = this.$route.path !== this.ROUTES.ROOT;
      document.documentElement.classList.toggle('--overflow', isOverflow)
    },

    // 'mq.sm' (sm) { setScrollable(sm ? window : this.$refs.main) },
  },

  computed: {
    isDebug () { return this.$route.query.debug !== undefined },
  },

  components: {
    Topbar,
    LndIntro,
    LndServices,
    LndProducts,
    LndAchs,
    LndContacts,
    LndClients,
    LndAreasOfWork,
    LndCases,
    LndTeam,
    LndAbout,
    LndGMP,
    LndWeDo,
    PrivacyPage,
    PrivacyContest,
    PrivacySetsModal,
    Particles,
    Lever,
    // Debug,
    IntroMap,
  },
};

</script>
<style>
.Root {
  --sep-c: #677b8c;
  --text-c: var(--white);
  --bg-c: rgba(255, 255, 255, .1);
  --bg-dark-c: rgba(0, 0, 0, .1);

  .__bgVideo {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -2;

    width: 100vw;
    height: 100vh;
    object-fit: cover;
    object-position: right;

    opacity: 0;

    transition: opacity .5s ease-out;

    pointer-events: none;

    &.--load { opacity: 1 }

    &.--bg2 {
      mix-blend-mode: screen;

      &.--load {
        opacity: .7;
      }
    }
  }

  main {
    display: flex;
    flex-direction: column;
    /*justify-content: center;*/

    overflow-y: auto;
    overflow-y: overlay;
    overscroll-behavior: none;
  }

}

html:after,
.Particles,
.Root__bg {
  transform: translateZ(-10000px);
  z-index: -2;
}
.Topbar { transform: translateZ(10000px); }

.LndSection {
  position: relative;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  color: var(--white);

  /*background: rgba(255, 255, 255, 0.9);*/
  /*background:
    linear-gradient(180deg, rgba(19, 45, 95, 0.9) 0%, rgba(0, 24, 70, 0.9) 100%),
    linear-gradient(180deg, rgba(32, 50, 84, 0) 70%, rgba(14, 23, 39, 0.3) 100%);*/

  &.--pad {
    --pad-v: 80px;
    padding: 0 var(--page-pad);
    padding-top: calc(var(--pad-v) + var(--topb-h));
    padding-bottom: var(--pad-v);
  }

  h2 {
    /*color: var(--accent-c);*/
    color: var(--white);
    font-weight: 500;
    font-size: 20px;
    line-height: 35px;
  }

  &.--bg { background: rgba(239, 243, 247, 0.85); }

  &.--bg-dark {
    color: var(--white);

    background: transparent;

    &:after {
      position: absolute;
      top: var(--topb-h);
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 0;

      display: block;

      background: rgba(21, 39, 73, 0.9);
      opacity: 0.7;

      content: '';
    }
  }
}

/*.--shit-bg:after {
  position: absolute;
  right: 5vw;
  bottom: 5vh;

  width: 50vw;
  height: 80vh;

  background: url('~assets/imgs/intro.svg');
  background-size: cover;
  background-repeat: no-repeat no-repeat;
  opacity: .4;

  content: '';
}*/

p,
span,
h1,
h2,
h3,
h4,
h5,
h6,
label,
img,
li,
a,
button {
  white-space: break-spaces;

  user-select: none !important;
}

@media (min-width: 740px) {
  html:not(.--overflow) { overflow: hidden }

  .Root {
    .LndSection {
      min-height: max(100vh, 821px);

      &:before {
        position: absolute;
        right: -20px;
        bottom: -30px;
        z-index: -1;

        font-weight: 700;
        font-size: 318px;
        line-height: 318px;

        opacity: .5;
      }

      /*&:nth-child(1):before { content: '1' }*/
      &:nth-child(2):before { content: '2' }
      &:nth-child(3):before { content: '3' }
      &:nth-child(4):before { content: '4' }
      &:nth-child(5):before { content: '5' }
      &:nth-child(6):before { content: '6' }
      &:nth-child(7):before { content: '7' }
      &:nth-child(8):before { content: '8' }
      &:nth-child(9):before { content: '9' }
    }

    &__bg {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      background:
        linear-gradient(180deg, rgba(73, 105, 168, 0.85) 0%, rgba(14, 48, 116, 0.85) 100%),
        linear-gradient(180deg, rgba(32, 50, 84, 0) 60%, rgba(14, 23, 39, 0.3) 100%);
    }

    main.u-span-y {
      --children-len: 8;
      height: 100vh;
      overflow-y: auto;
      overflow-y: overlay;
      scroll-snap-type: y mandatory;
      scroll-behavior: smooth;

      > *:not(.u-span-y__exclude) {
        position: relative;
        /*top: calc(var(--children-len) * 0.5 * max(100vh, 821px));*/
        scroll-snap-align: start;
      }
    }

    .Lever {
      position: fixed;
      bottom: calc(80px - var(--size) - 8px);
      left: var(--page-pad);
      z-index: var(--zi-higher);
    }

    .__pages .LndSection:before { content: '' }
  }
}

@media (max-width: 739px) {
  .Root {
    .LndSection {
      --pad-v: 24px;

      padding-bottom: 80px;

      &.--sm-mh {
        min-height: var(--vh);
      }
    }

    .__bgVideo {
      position: fixed;
    }

    /*.Particles {
      height: calc(100vh + 55px) !important;
    }*/
    main {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      display: block;
      overflow-y: auto;
      overflow-y: overlay;
      overscroll-behavior: none;
    }
  }
  html {
    /*z-index: -1;*/
    background: rgba(14, 48, 116, 0.85);
    overflow: hidden;
  }

  html:after {
    position: fixed;
    top: 0;
    right: 0;
    /*bottom: 0;*/
    left: 0;
    z-index: -1;

    height: calc(100vh + 75px) !important;

    background:
      linear-gradient(180deg, rgba(73, 105, 168, 0.85) 0%, rgba(14, 48, 116, 0.85) 100%),
      linear-gradient(180deg, rgba(32, 50, 84, 0) 60%, rgba(14, 23, 39, 0.3) 100%);

    content: '';
  }
}
</style>
